import React from "react";
import { Link } from "react-router-dom";
import "../../Components/settings/settings.css";

const AboutUs = () => {
  return (
    <div className="page">
      <div className="settings-container">
        <h2 className="settings-page-title">About Us</h2>

        <section className="about-section">
          <p>
            We've created a platform where creators take the lead. Our mission
            is simple: give content creators the tools, freedom, and audience
            they need to turn their ideas into fully realized shows.
          </p>
        </section>

        <section className="about-section">
          <p>
            We believe great content doesn't come from gatekeepers—it comes from
            the passionate and highly motivated people with something to prove.
            That's why we've created a space where creators can develop, launch,
            and grow their own series on their own terms, while connecting
            directly with their audience.
          </p>
        </section>

        <section className="about-section">
          <p>
            Whether it's entertainment, education, storytelling, or something
            entirely new, our platform empowers creators to build their brand,
            own their content, and shape the future of media.
          </p>
        </section>

        <section className="about-section">
          <p>
            Founded in 2024, we started with a vision to redefine how shows are
            created and shared—putting creative control back where it belongs: in
            the hands of the creators.
          </p>
        </section>

        <section className="about-section">
          <h3>Support</h3>
          <p>
            Have questions or need help? We're here for you.{" "}
            <Link to="/contact-us">Contact our support team</Link> and we'll get
            back to you as soon as possible.
          </p>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;
